import {FC} from "react";
import Container from "@mui/material/Container";

type Props = {
    codeCatalogHeader?: React.ReactNode;
    children?: React.ReactNode;
}
const CodeCatalogWrapper: FC<Props> = ({children, codeCatalogHeader}) => {
    return (
        <Container sx={{my:2, padding:0}}>
            {codeCatalogHeader}
            {children}
        </Container>
    )
}
export default CodeCatalogWrapper;